/**
 * BMS (Booking Management) shared helpers and re-exports.
 * Use this instead of duplicating formatDate, formatCurrency, styles, etc. in each component.
 */
import {
  formatDate,
  formatCurrency,
  formatCurrencyNoDecimals,
  formatDateTime,
  numberToWords,
  getPaymentStatusColor,
  getInitials,
} from '../../utils/helper';
import {
  bookingTokens,
  cardSx,
  cardHeadSx,
  tableHeadSx,
  emptyStateSx,
  primaryButtonSx,
  ghostButtonSx,
  statBoxSx,
  statBoxAccentSx,
  STATUS_CFG,
} from './booking_details/bookingDetailsTheme';

// Re-export from helper
export {
  formatDate,
  formatCurrency,
  formatCurrencyNoDecimals,
  formatDateTime,
  numberToWords,
  getPaymentStatusColor,
  getInitials,
};

// Re-export from booking details theme
export {
  bookingTokens,
  cardSx,
  cardHeadSx,
  tableHeadSx,
  emptyStateSx,
  primaryButtonSx,
  ghostButtonSx,
  statBoxSx,
  statBoxAccentSx,
  STATUS_CFG,
};

/** Number to en-IN locale string (no symbol). Use for inline amounts e.g. ₹{fmt(amount)} */
export const fmt = (n) => Number(n || 0).toLocaleString('en-IN');

/** Format date for list views (2-digit year). */
export const formatDateShort = (d) =>
  d ? new Date(d).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: '2-digit' }) : '—';

/** Return { date, time } for activity/timeline display (en-IN). */
export const formatActivityDateTime = (timestamp) => {
  const date = new Date(timestamp);
  return {
    date: date.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }),
    time: date.toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit' }),
  };
};

/** Relative day label (Today, Yesterday, 3d ago, etc.) */
export const daysSince = (d) => {
  if (!d) return null;
  const diff = Math.floor((Date.now() - new Date(d)) / 86400000);
  if (diff === 0) return 'Today';
  if (diff === 1) return 'Yesterday';
  if (diff < 7) return `${diff}d ago`;
  if (diff < 30) return `${Math.floor(diff / 7)}w ago`;
  return `${Math.floor(diff / 30)}mo ago`;
};
